import { useEffect, useRef } from 'react';

export default function Modal({ children, labelledBy, onClose, busy = false }) {
  const dialogRef = useRef(null);
  useEffect(() => {
    const dialog = dialogRef.current;
    // jsdom has no dialog implementation; browsers use native focus and inertness.
    if (dialog.showModal) dialog.showModal();
    else dialog.setAttribute('open', '');
    return () => dialog.close?.();
  }, []);
  return <dialog ref={dialogRef} className="popupOverlay" closedby={busy ? 'none' : 'closerequest'} aria-labelledby={labelledBy} onCancel={event => { event.preventDefault(); if (!busy) onClose(); }}>{children}</dialog>;
}
